// src/config.js
const getApiBaseUrl = () => {
  const hostname = window.location.hostname;
  
  // 开发环境
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3001';
  }
  
  // ✅ 生产环境：使用相对路径，让 Nginx 代理
  return '';  // 空字符串，表示使用相对路径
};

const API_BASE_URL = getApiBaseUrl();
export default API_BASE_URL;
export { API_BASE_URL };

console.log('🌐 API Base URL:', API_BASE_URL || '(相对路径)');